export default function Dining() {
  return (
    <section className="max-w-6xl mx-auto px-4 py-12 space-y-4">
      <h1 className="text-3xl font-semibold tracking-tight">Dining & BBQ</h1>
      <p className="text-muted-foreground">
        Order a breakfast set or enjoy an evening BBQ under the stars. We provide grills, charcoal,
        and local ingredients on request.
      </p>
    </section>
  );
}
